<template>
  <div>
    <div class="title">使用优惠券的订单如何退款？</div>
    <div class="content-info">
      <p class="txt1">按优惠后的金额退款。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
